import { WorkloadTableItem } from "../../../../mst/kinds/workload.helpers";
import { TableColumn } from "../../types";

const readyLocationsDefault = { id: "readyLocations", label: "Ready Locations" };
export function WorkloadReadyLocationsColumn<TData extends WorkloadTableItem>(
  column: TableColumn<TData> = readyLocationsDefault,
) {
  const preset: TableColumn<TData> = {
    ...readyLocationsDefault,
    enableHide: true,
    hiddenByDefault: true,
    size: 170,
    cell: (p) => {
      const workload = p.row.original;
      if (workload.readyLocations == null || workload.totalLocations == null) return <span>-</span>;
      return (
        <span>
          {workload.readyLocations}/{workload.totalLocations}
        </span>
      );
    },
  };
  return Object.assign(preset, column);
}
